import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeDeviceDetailsComponent } from './components/home-device-details/home-device-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LazyElementsModule } from '@angular-extensions/elements';
import { EditHomeDeviceDetailsModalComponent } from 'src/app/modules/home-devices/components/edit-home-device-details-modal/edit-home-device-details-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadReceiptModalComponent } from './components/upload-receipt-modal/upload-receipt.modal.component';
import { DeviceInventoryComponentV3 } from './components/device-inventory-v3/device-inventory-v3.component';
import { MatChipsModule } from '@angular/material/chips';
import { AutocompleteDeviceSearchComponent } from './components/device-autocomplete/device-autocomplete.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DeviceDetailsDialogComponent } from './components/device-details-dialog/device-details-dialog.component';
@NgModule({
    declarations: [
        DeviceInventoryComponentV3,
        HomeDeviceDetailsComponent,
        EditHomeDeviceDetailsModalComponent,
        UploadReceiptModalComponent,
        AutocompleteDeviceSearchComponent,
        DeviceDetailsDialogComponent     
    ],
    imports: [
        CommonModule,
        SharedModule,
        LazyElementsModule,
        MatChipsModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule
    ]
})
export class HomeDevicesModule { }
